import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  FormControlLabel,
  Checkbox,
  LinearProgress,
  Button,
} from '@material-ui/core';
import { Form } from '@unform/web';
import { isEmpty } from 'lodash';

import { Modal } from '~/components';
import { DateTime } from '~/components/Form';
import { t } from '~/helpers';
import { validationErrors } from '~/helpers/yupValidations';
import api from '~/services/api';

import { Table, UpdateNozzle, SimpleTable } from './components';
import * as S from './styles';

export default function TrocaTanque() {
  const [tank, setTank] = useState(null);
  const [product, setProduct] = useState(null);
  const [mirror, setMirror] = useState(true);
  const [retroactive, setRetroactive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSend, setIsSent] = useState(false);

  const { client, id } = useSelector((state) => state.user.profile);

  const formRef = useRef(null);
  const modalRef = useRef(null);

  const cellsTank = useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.configuracao.terminal.nomeposto'),
      },
    ],
    []
  );

  const cellsProducts = useMemo(
    () => [
      // { id: 'idproduto', label: t('s.operacao.recebimento.idproduto') },
      {
        id: 'codigoauxiliarproduto',
        label: t('s.operacao.recebimento.idproduto'),
      },
      {
        id: 'nomeabreviadoproduto',
        label: t('s.geral.camposistema.nomeabreviadoproduto'),
      },
    ],
    []
  );

  const handleSubmit = useCallback(
    async (data, { reset }) => {
      try {
        setLoading(true);

        if (!data.bicos) {
          toast.error(t('Nenhum bico alterado!'));
          return;
        }

        const beaks = data.bicos.filter(Boolean);

        if (isEmpty(beaks)) {
          toast.error(t('Nenhum bico alterado!'));
          return;
        }

        const formData = data.bicos
          .map((nozzle, key) => {
            if (isEmpty(nozzle)) {
              return '';
            }

            return {
              idtrocatanque: null,
              idcliente: client,
              idposto: tank,
              idbico: Number(data.ids[key]),
              idusuario: id,
              idtanquevirtualanteriortrocatanque: nozzle,
              idtanquevirtualalinhadotrocatanque: nozzle,
              datahorainiciotrocatanque: data.datahorainiciotrocatanque || null,
              datahorafimtrocatanque: null,
            };
          })
          .filter(Boolean);

        await api.post('/trocastanques', formData);

        reset();
        setIsSent(true);

        toast.success(t('s.geral.sucessoalteracao'));
      } catch (err) {
        validationErrors(err, formRef);
      } finally {
        setLoading(false);
      }
    },
    [tank, id, client]
  );

  useEffect(() => {
    if (isSend) setIsSent(false);
  }, [isSend]);

  return (
    <Form ref={formRef} onSubmit={handleSubmit}>
      {loading && <LinearProgress />}

      <S.WrapperHeader>
        <S.WrapperFormInput>
          <FormControlLabel
            control={
              <Checkbox
                checked={retroactive}
                onChange={({ target }) => setRetroactive(target.checked)}
                color="primary"
              />
            }
            label={t('s.operacao.trocatanque.trocatanqueretroativo')}
          />

          {retroactive && (
            <DateTime
              time
              name="datahorainiciotrocatanque"
              label={t('s.relatorio.descarga.datahora')}
            />
          )}
        </S.WrapperFormInput>

        <S.WrapperFormInput>
          <FormControlLabel
            control={
              <Checkbox
                checked={mirror}
                onChange={({ target }) => setMirror(target.checked)}
                color="primary"
              />
            }
            label={t('s.operacao.trocatanque.mantermesmotanquenosbicos')}
          />

          <Button
            size="small"
            color="primary"
            variant="contained"
            disabled={loading || !tank || !product}
            onClick={() => modalRef.current.handleOpenModal()}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>
        </S.WrapperFormInput>
      </S.WrapperHeader>

      <S.Wrapper>
        <S.WrapperTable>
          <h1>{t('s.menu.configuracao.posto')}</h1>

          <SimpleTable
            dense
            cells={cellsTank}
            onCreate={false}
            onUpdate={false}
            onDelete={false}
            onCallbackClick={(value) => setTank(value.idposto)}
            url="/postos?pagesize=9999"
            unique="idposto"
            height="80vh"
          />
        </S.WrapperTable>

        <S.WrapperTable>
          <h1>{t('s.menu.configuracao.produto')}</h1>

          <SimpleTable
            dense
            cells={cellsProducts}
            onCreate={false}
            onUpdate={false}
            onDelete={false}
            onCallbackClick={(value) => setProduct(value.idproduto)}
            url="/produtos"
            unique="idproduto"
            height="80vh"
          />
        </S.WrapperTable>

        <S.WrapperTable>
          <h1>{t('s.menu.configuracao.bico')}</h1>

          <Table
            tank={tank}
            product={product}
            mirror={mirror}
            form={formRef}
            sent={isSend}
          />
        </S.WrapperTable>
      </S.Wrapper>

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        maxWidth="xs"
        title={t('s.geral.tarefa.put')}
        component={UpdateNozzle}
        onForm={() => formRef.current.submitForm()}
      />
    </Form>
  );
}
